import { Title } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import type { FC } from "react";

type SectionHeader = {
  title: string;
};
export const SectionHeader: FC<SectionHeader> = ({ title }) => {
  const matches = useMediaQuery("(max-width: 768px)");

  return (
    <Title order={2} mb={8} size={matches ? 16 : 18}>
      {title}
    </Title>
  );
};
